(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDevices', TabDevices);

    TabDevices.$inject = ['$resource'];

    function TabDevices ($resource) {
        var resourceUrl =  'api/tab-devices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
